var THREE         = require("three");
var GUIHandleView  = require("./guiHandleView.js");
var lib_core      = require("lib-core");

var PositionHandleView = function (model, editorView, handleId, config) {
    GUIHandleView.call(this, model, editorView, handleId, config);
}

lib_core.inherit(PositionHandleView, GUIHandleView);

PositionHandleView.prototype.repositionMesh = function(mesh, position){
    console.error("not implimented");
}

PositionHandleView.prototype.buildMesh = function(radius){
    console.error("not implimented");
}


PositionHandleView.prototype.buildGeometry = function(radius){
    var handleSize = this.config.size * (radius/10);
    var handleSpacing = this.extraRadius * (radius/10);

    var height = radius/2;
    var rad = radius/20;
    var shape = new THREE.ConeGeometry( 
        rad, 
        height, 
        32 );
    //shape.translate(0, radius + handleSize + handleSpacing + radius/2, 0);
    shape.translate(0, height/2 + rad, 0);
    shape.rotateX(Math.PI/2);
    return shape;
}

module.exports = PositionHandleView;

